import axios from 'axios'
import { CADASTRAR_PRECO, IMPORTAR_PRECO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export function cadastrarPreco (preco) {
  const url = `${URL}/preco/cadastrar`;
  return dispatch => axios.post(url,preco , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_PRECO,
        payload: response
      })
  );
}

export function importarPrecos (codigoEmpresaOrigem, codigoEmpresaDestino, tipoVeiculo, tipoVeiculoAImporta) {
  let url = `${URL}/preco/empresa-origem/${codigoEmpresaOrigem}/empresa-destino/${codigoEmpresaDestino}/importar`;
  if(tipoVeiculo.length > 1) {
    url += `?tipoPreco=${tipoVeiculo}`
  }

  if (tipoVeiculo.length > 1 && tipoVeiculoAImporta.length > 1) {
    url += `&tipoPrecoAImportar=${tipoVeiculoAImporta}`
  }

  return dispatch => axios.get(url,SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: IMPORTAR_PRECO,
      payload: response
    })
  );
}
